/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_AvisoActualizacion as AvisoActualizacion,
  rec_InstalacionYConexion as InstalacionYConexion,
  rec_JSXRuntime as JSXRuntime,
  rec_ProveedorAvisos as ProveedorAvisos,
  rec_ProveedorDialogos as ProveedorDialogos,
  rec_React as React,
  rec_ReactCompiler as ReactCompiler,
  rec_RutasAplicacion as RutasAplicacion,
  rec_jo as jo,
  rec_x3 as x3,
  rec_xn as xn,
} from "../../runtime/index.jsx";
export function App() {
  let e = (0, ReactCompiler.c)(3),
    t,
    n;
  e[0] === Symbol.for(`react.memo_cache_sentinel`)
    ? ((t = (0, JSXRuntime.jsx)(jo, {})),
      (n = (0, JSXRuntime.jsx)(x3, {})),
      (e[0] = t),
      (e[1] = n))
    : ((t = e[0]), (n = e[1]));
  let r;
  return (
    e[2] === Symbol.for(`react.memo_cache_sentinel`)
      ? ((r = (0, JSXRuntime.jsxs)(xn, {
          children: [
            t,
            n,
            <ProveedorAvisos
              children={
                <ProveedorDialogos
                  children={[
                    <RutasAplicacion />,
                    <InstalacionYConexion />,
                    <AvisoActualizacion />,
                  ]}
                />
              }
            />,
          ],
        })),
        (e[2] = r))
      : (r = e[2]),
    r
  );
}
